// Sort control on the public asset browse pages.
//
// One `sort` param, handled here rather than through products/_sort +
// sort.js: that script's js-order-by branch only knows how to clear the
// product sort family (sort_price / sort_sales / sort_reviews / sort_date), so
// an assets sort would survive a switch and leave two live sort params in the
// URL. The <select> renders its own selected option server-side, so this only
// has to handle the change. Delegated, because the select sits inside the
// results region that catalog navigation swaps without a page load.

$(document).on("change", ".js-assets-sort", function () {
  const url = new URL(window.location.href)
  url.searchParams.set("sort", this.value)
  // A new ordering makes the old page number meaningless.
  url.searchParams.delete("page")
  Turbolinks.visit(url.toString())
})

// Sidebar catalog branches remember whether they are open. The boot script in
// assets/_sidebar applies the stored state before paint and again after each
// results swap (closed unless opened, or the active catalog is inside, or it
// is the default top-level branch -- Materials, else Models, else the first
// -- and was never toggled); this only records the changes. Bootstrap
// re-dispatches its events through jQuery when jQuery is present, so a
// delegated handler sees them.
const GROUPS_KEY = "assetsFilterGroups"

function rememberBranch(key, open) {
  try {
    const stored = JSON.parse(localStorage.getItem(GROUPS_KEY) || "{}") || {}
    stored[key] = open
    localStorage.setItem(GROUPS_KEY, JSON.stringify(stored))
  } catch {
    // Storage can throw with cookies blocked; the branch still toggles,
    // it just won't be remembered.
  }
}

$(document).on(
  "shown.bs.collapse hidden.bs.collapse",
  ".assets-filter-node > .collapse",
  function (event) {
    // The panel's parent, not closest(): branches nest, and the one that
    // toggled is the one to record.
    const key = this.parentElement.dataset.filterNode
    if (key !== undefined) rememberBranch(key, event.type === "shown")
  }
)

// Clicking a parent catalog's name filters to it (results_swap.js) and also
// opens its branch; only the chevron beside it closes one. Opened here
// rather than left to the swap -- which re-renders the branch open anyway,
// since the active catalog is inside it -- so it opens on the click, and is
// remembered so it stays open after the visitor filters elsewhere.
$(document).on(
  "click",
  ".assets-filter-node-row > .asset-browse-catalog-link",
  function () {
    const node = this.closest(".assets-filter-node")
    const panel = node.querySelector(":scope > .collapse")
    const toggle = node.querySelector(
      ":scope > .assets-filter-node-row > [data-bs-toggle=collapse]"
    )
    if (!panel || !toggle) return

    panel.classList.add("show")
    toggle.classList.remove("collapsed")
    toggle.setAttribute("aria-expanded", "true")
    rememberBranch(node.dataset.filterNode, true)
  }
)

// Card-size toggle (assets/_grid_size_toggle): small, medium or large cards.
// One grid markup; the size is a class on its wrapper. The boot script in
// assets/_browse applies the stored size before paint and after each results
// swap, so this only has to handle the click. Everything is re-queried, never
// captured: a swap replaces both the grid and the buttons.
const SIZE_KEY = "assetsPublicGridSize"
const SIZES = ["sm", "md", "lg"]

function applyGridSize(size) {
  $(".js-asset-grid")
    .removeClass(SIZES.map((s) => "asset-grid-" + s).join(" "))
    .addClass("asset-grid-" + size)

  $(".js-asset-grid-size").each(function () {
    const active = this.dataset.size === size
    $(this).toggleClass("active", active).attr("aria-pressed", String(active))
  })
}

$(document).on("click", ".js-asset-grid-size", function () {
  const size = this.dataset.size
  if (!SIZES.includes(size)) return

  try {
    localStorage.setItem(SIZE_KEY, size)
  } catch {
    // Storage can throw with cookies blocked; the grid still resizes, it
    // just won't be remembered.
  }
  applyGridSize(size)
})

// Dismissible callouts in the assets hero (the welcome banner on /assets, "How
// Asset Libraries Work" on the libraries page). Dismissing one is remembered
// under its data-dismiss-key; the boot script in assets/_hero hides it before
// paint and after each results swap, so this only has to handle the click.
// Focus moves to the page title, since the button that had it is about to
// disappear.
$(document).on("click", ".js-dismissable-callout-dismiss", function () {
  const callout = this.closest(".js-dismissable-callout")
  if (!callout) return

  try {
    localStorage.setItem(callout.dataset.dismissKey, "1")
  } catch {
    // Storage can throw with cookies blocked; the callout still closes, it
    // just comes back next visit.
  }
  callout.hidden = true

  const title = document.querySelector(".assets-hero-title")
  if (title) {
    title.setAttribute("tabindex", "-1")
    title.focus()
  }
})
